import {Router, RouterStateSnapshot, NavigationExtras, ActivatedRoute} from '@angular/router';
import { Injectable } from "@angular/core";
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { DashboardService } from '../../../worklist/services/dashboard.service';
import { NavigationConfigService } from '@ispm/dashboard/navigation/services/navigationConfig.service';
import { get, has } from 'lodash';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { LoginAuthService } from '../../../authorization/services/login-auth.service';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';

@Injectable({ providedIn: 'root' })
export class resolveClinicalParams {
  constructor(private dashboardService: DashboardService) {
  }

  resolve() {
    return this.dashboardService.getClinicalUsageMessage();
  }
}

@Injectable({ providedIn: 'root' })
export class resolveWebConfigParams {
  constructor(private workflowService: WorkflowService,
              private navigationConfigService: NavigationConfigService,
              private router: Router,
              private authService: AuthenticationService,
              private loginAuthService: LoginAuthService,
              private routerManagerService: RouterManagerService,
  ) {
  }
  resolve(route: Router, state: RouterStateSnapshot) {
    const currUser = this.authService.user;
    const queryParameters = this.routerManagerService.queryParameters;
    const adminUser = this.authService.isAdminUser();
    const sysAdminUser = this.authService.isSysAdminUser();
    const isNavFromAdmin = sessionStorage.getItem('isNavFromAdmin');
    // If clause should only get executed on fresh page load
    if (adminUser &&
        this.authService.doesUserHasPermission('ADMIN.LOGIN.USER') &&
        !(queryParameters['u-code'] || this.routerManagerService.currentPageUrl.includes('/admin/settings') || isNavFromAdmin)
       ) {
        this.loginAuthService.redirectionToDashboard(currUser);
    }
    else if(!sysAdminUser || isNavFromAdmin) {
      /**
       *  For Admin user web configuration will be empty, for admin user below code block is not required
       *  Admin user refresh will have a problem, if a organization was selected from dropdown without else.
       *  Condition - isNavFromAdmin - check is required from admin user, navigation to application comes under this clause
       */
      return this.workflowService.getDashboardConfig().then(data => {
        if (route.url !== '/dashboard/setting/base') {
          return this.navigationConfigService.requestWebConfiguration().toPromise().then(webConfig => {
            const navigationItems = (webConfig.navigation?.hasOwnProperty('items')) ? webConfig.navigation.items : webConfig.navigation;
            const selectedNav = get(webConfig?.navigation?.selected, currUser?.role , '');
            // const navigationItems = (webConfig.navigation.hasOwnProperty('items')) ? webConfig.navigation.items : webConfig.navigation;
            if (!this.navigationConfigService.checkingUserPermission(route, webConfig)) {
              const items = Array.isArray(navigationItems) ? navigationItems.filter(nav => nav.enable) : [];

              // const items = navigationItems.filter(nav => nav.enable);
              if (items.length > 0) {
                const firstItem = items.find(i => i.appid === webConfig.currentApp.id) || items[0];
                const firstStateRedirect = this.navigationConfigService.getStateFromUri(firstItem);
                const queryParams = this.navigationConfigService.getUrlQueryParams(firstItem.redirectUrl);
                const navigationExtras: NavigationExtras = {
                  queryParams: queryParams
                }
                if(this.navigationConfigService.getStateNameFromUri(state.url) !== firstStateRedirect) {
                  this.router.navigate([firstStateRedirect], navigationExtras);
                }
              } else {
                console.error("Configuration Error No Navigation Location to send");
                this.router.navigate(['unauthorized']);
                // $state.go('unauthorized');//no where redirect go to unauthorized page
              }
            }
            else {
              this.navigationConfigService.getCurrentApp().subscribe((app) => {
                if ((app && app.items) && app.items.length > 0) {
                  const items = app.items.filter(nav => nav.enable);
                  const validateSearchParams = window.location.pathname === "/saml/login" && !window.location.search.includes('testNumber') && !window.location.search.includes('patientId');
                  if (((window.location.pathname === "/" || window.location.pathname === "/login") && window.location.search === "") || validateSearchParams) {
                    // items[0] - will override the default navigation if other than zero index after login and base path
                    let _firstItem = items[0];
                    for (const navItem of items) {
                      if (navItem.enable && selectedNav === navItem.identify){
                        _firstItem = navItem
                      }
                    }
                    const _firstStateRedirect = this.navigationConfigService.getStateFromUri(_firstItem);
                    const _queryParams = this.navigationConfigService.getUrlQueryParams(_firstItem.redirectUrl);
                    const navigationExtras: NavigationExtras = {
                      queryParams: _queryParams
                    }
                    if(this.navigationConfigService.getStateNameFromUri(state.url) !== _firstStateRedirect) {
                      this.router.navigate([_firstStateRedirect], navigationExtras);
                    }
                  }
                  else if (window.location.pathname !== "/" && window.location.search !== "") {
                    const urlParams = this.navigationConfigService.getUrlQueryParams(window.location.pathname);
                    const appNameStr = "appname";
                    let paramValue = urlParams[appNameStr];
                    if (paramValue && paramValue != "") {
                      paramValue = paramValue.toLowerCase()
                      const navItem = items.find(item => (item.redirectUrl !== "" && item.redirectUrl.toLowerCase().includes("?" + appNameStr + "=" + paramValue)));
                      const _firstStateRedirect = this.navigationConfigService.getStateFromUri(navItem);
                      const _queryParams = this.navigationConfigService.getUrlQueryParams(navItem.redirectUrl);
                      const navigationExtras: NavigationExtras = {
                        queryParams: _queryParams
                      }
                      if(this.navigationConfigService.getStateNameFromUri(state.url) !== _firstStateRedirect) {
                        this.router.navigate([_firstStateRedirect], navigationExtras);
                      }
                    }
                  }
                }
              });
            }
            return get(data,'body', {});
          })
        }
      })
    }
  }
}


